import React, { useState, useEffect } from 'react';
import {
  DashboardOutlined,
  DownloadOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  NotificationOutlined,
  ProfileFilled,
  UploadOutlined,
  UserOutlined,
  BellOutlined,
  MailFilled,
  WindowsFilled,
  MailOutlined,
  BoxPlotOutlined,
  InboxOutlined
} from '@ant-design/icons';
import { App, Button, Layout, Menu, Watermark } from 'antd';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Logo from "../assests/TFS Logo.png";
import watermark from "../assests/watermark.png"
import { getUser, logout } from '../../authService';
import UserDropdown from '../components/UserDropdown';
import ThemeSetting from '../../User-panel/components/ThemeSetting';
import SwitchButton from '../components/SwitchButton';

const { Header, Sider, Content } = Layout;

const MasterTemplate = () => {
  const { modal } = App.useApp()
  const [user, setUser] = useState(null);
  const [master_loder, set_master_loder] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  // const [balck_theme, set_balck_theme] = useState(true);



  useEffect(() => {
    getUser().then(usr => {
      // console.log(usr)
      setUser(usr);
      set_master_loder(false)
    });
  }, []);


  useEffect(() => {
    const pathToKey = {
      '/': { selected: '6' },
      '/learners': { selected: '3', open: '2' },
      '/add-learner': { selected: '3', open: '2' },
      '/edit-learner': { selected: '3', open: '2' },
      '/learners-group': { selected: '12', open: '2' },
      '/assign-learner': { selected: '12', open: '2' },
      '/instructors': { selected: '4', open: '2' },
      '/add-instructors': { selected: '4', open: '2' },
      '/import-instructors': { selected: '4', open: '2' },
      '/courses': { selected: '6', open: '5' },
      '/add-courses': { selected: '6', open: '5' },
      '/edit-course': { selected: '6', open: '5' },
      '/course-learners': { selected: '6', open: '5' },
      '/learner-report': { selected: '6', open: '5' },
      '/packages': { selected: '7', open: '5' },
      '/add-packages': { selected: '7', open: '5' },
      '/edit-package': { selected: '7', open: '5' },
      '/course-report': { selected: '9', open: '8' },
      '/package-report': { selected: '10', open: '8' },
      '/quiz-report': { selected: '11', open: '8' },
      // '/media': { selected: '8' },
       '/report': { selected: '9' },
       '/download': { selected: '10' },
      // '/notification': { selected: '13' },
      // '/add-notification': { selected: '13', open: '13' },
      // '/edit-notification': { selected: '13', open: '13' },
      // '/smtp': { selected: '16' },
      // '/add-smtp': { selected: '16', open: '16' },
      // '/edit-smtp': { selected: '16', open: '16' },
      // '/announcements': { selected: '15' },
      // '/add-announcement': { selected: '15', open: '15' },
      // '/edit-announcement': { selected: '15', open: '15' },
      // '/deleted-courses': { selected: '14', open: '5' },
      // '/microsoft': { selected: '18', open: '17' },
      // '/add-microsoft': { selected: '18', open: '17' },
      // '/edit-microsoft': { selected: '18', open: '17' },
      // '/pre-email-template': { selected: '19', open: '19' },
      // '/add-pre-email-template': { selected: '19', open: '19' },
      // '/edit-pre-email-template': { selected: '19', open: '19' },
      // '/sub-admin': { selected: '20', open: '2' },
      // '/add-sub-admin': { selected: '20', open: '2' },
      // '/edit-sub-admin': { selected: '20', open: '2' },

    };
    const path = location.pathname;
    const match = pathToKey[path];
    if (match) {
      setSelectedKeys([match.selected]);
      if (match.open) {
        setOpenKeys([match.open]);
      } else {
        setOpenKeys([]);
      }
    }
    // const local_theme = localStorage.getItem("dark_theme");
    // local_theme === 'dark' ? set_balck_theme(1) : set_balck_theme(0);
  }, [location.pathname]);


  const handleMenuClick = ({ key }) => {
    const keyToPath = {
      '6': '/',
      '3': '/learners',
      '4': '/instructors',
      '6': '/courses',
      '7': '/packages',
      '9': '/course-report',
      '10': '/package-report',
      '11': '/quiz-report',
      // '8': '/media',
        '9': '/report',
        '10': '/download',
      // '12': '/learners-group',
      // '13': '/notification',
      // '14': '/deleted-courses',
      // '15': '/announcements',
      // '16': '/smtp',
      // '18': '/microsoft',
      // '19': '/pre-email-template',
      // '20': '/sub-admin'

    };


    const route = keyToPath[key];
    if (route) {
      navigate(route);
    } else if (key === '50') {
      modal.confirm({
        title: "Are you sure you want to logout?",
        okText: "Logout",
        cancelText: "Cancel",
        onOk: () => {
          logout();
        },
      });
    }
  };

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  if (!user) {
    return <Navigate path="/" />
  }

  return (
    <>
      {master_loder ? <>
        Loading...........
      </> : <>
        <Layout style={{ minHeight: '100vh' }}>
          {/* <Sider trigger={null} collapsible collapsed={collapsed} style={balck_theme ? { background: "#fff" } : { background: "#fff" }}> */}
          <Sider trigger={null} collapsible collapsed={collapsed} style={{ backgroundColor: "#fff" }}>
            {/* <div style={{ marginTop: "10px", height: "80px", textAlign: "center", marginLeft: "10px", marginRight: "10px" }}>
              <img alt="logo" src={Logo} style={{ width: "100%", height: "70%",borderRadius:"30px" }} />
            </div> */}

            <div
              style={{
                marginTop: "10px",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <img
                alt="logo"
                src={Logo}
                style={{

                  width: "125px",
                  objectFit: "contain",
                  marginTop: collapsed ? "-5px" : "-5px",
                  marginLeft: collapsed ? "-12px" : "0px",

                }}
              /><br />
              {!collapsed && (
                <h6 style={{ marginTop: "-10px", color:"#141414", fontSize: "16px" }}> Travel Food Services</h6>

              )}
            </div>
                {/* <h6 style={{ marginTop: "-10px", color: balck_theme ? "#141414" : "#141414", fontSize: "16px" }}> Travel Food SErvices</h6> */}

            <Menu
              // theme="dark"
              mode="inline"
              style={{ marginTop: "15px" }}
              selectedKeys={selectedKeys}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              onClick={handleMenuClick}
              items={[

                // {
                //   key: '2',
                //   icon: <UserOutlined />,
                //   label: 'Users',
                //   children: [
                //     //  { key: '20', label: "Sub Admin" },
                //     { key: '3', label: "Learners" },
                //     // { key: '12', label: "Learners Group" },

                //     // { key: '4', label: "Instructors" }
                //   ]
                // },
                {
                  key: '6',
                  icon: <FileTextOutlined />,
                  label: 'Courses',
                },
                {
                  key: '7',
                  icon: <InboxOutlined style={{ fontSize: "18px" }} />,
                  label: 'Modules',
                },
                {
                  key: '3',
                  icon: <UserOutlined />,
                  label: 'Learners/Sub Admin',
                },
                // {
                //   key: '5',
                //   icon: <FileTextOutlined />,
                //   label: 'Content',
                //   children: [
                //     { key: '6', label: "Courses" },
                //     // { key: '14', label: "Deleted Courses" },
                //     { key: '7', label: "Modules" },

                //   ]
                // },
                {
                  key: '9',
                  icon: <FileTextOutlined />,
                  label: 'Report',
                },
                //                 {
                //                   key: '8',
                //                   icon: <ProfileFilled />,
                //                   label: 'Media',
                //                 },

                // {
                //                   key: '19',
                //                   icon: <MailOutlined />,
                //                   label: 'Pre Define Email Template',
                //                 },

                //                 {
                //                   key: '13',
                //                   icon: <BellOutlined />,
                //                   label: 'Notifcation',
                //                 },

                // {
                //   key: '16',
                //   icon: <MailFilled />,
                //   label: 'Smtp',
                // },

                // {
                //   key: '15',
                //   icon: <NotificationOutlined />,
                //   label: 'Announcements',
                // },

                //  {
                //    key: '9',
                //    icon: <FileSearchOutlined />,
                //    label: 'Report',
                //  },

                 {
                   key: "10",
                   icon: <DownloadOutlined />,
                   label: 'Download',
                 },


                // {
                //   key: '17',
                //   icon: <WindowsFilled />,
                //   label: 'SSO',
                //   children: [
                //     { key: '18', label: "Microsoft" },


                //   ]
                // },
                // {
                //   key: '11',
                //   icon: <SettingFilled />,
                //   label: 'Setting',
                // },
                {
                  key: '50',
                  icon: <UploadOutlined />,
                  label: 'Logout',
                },
              ]}
            />
          </Sider>
          <Layout>
            <Header
              style={{
                padding: "0 10px",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: "#141414",
              }}>
              {/* // style={
              //   balck_theme
              //     ? {
              //       padding: "0 10px",
              //       backgroundColor: "#141414",
              //       display: "flex",
              //       alignItems: "center",
              //       justifyContent: "space-between",
              //       color: "#fff",
              //     }
              //     : {
              //       padding: "0 10px",
              //       backgroundColor: "#fff",
              //       display: "flex",
              //       alignItems: "center",
              //       justifyContent: "space-between",
              //       color: "#141414",
              //     }
              // }> */}
              <div>
                <Button
                  type="text"
                  icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                  onClick={() => setCollapsed(!collapsed)}
                  style={{
                    fontSize: '16px',
                    width: 64,
                    height: 64,
                    // color: balck_theme ? "#fff" : "#141414",
                    color: "#141414"
                  }}
                />
                <span style={{ fontWeight: "bold", fontSize: "20px" }}>
                  Sub Admin
                </span>
                <SwitchButton />
              </div>

              <div style={{ float: "right", display: "flex", gap: "20px", alignItems: "center" }}>
                {/* <ThemeSetting set_theme_style={set_balck_theme} /> */}
                <UserDropdown user={user} />
              </div>

            </Header>
            <Content style={{backgroundColor:"#e6e6e6ff"

            }
              // balck_theme
              //   // ? { backgroundColor: "#000000" }
              //   ? { backgroundColor: "#e6e6e6ff" }
              //   : ""
            }>
              {/* <Watermark
                image={watermark}
                rotate={0}
                width={300}
                height={400}         
                gap={[200, 200]}    
                offset={[0, 0]}
              > */}
              <Outlet />
              {/* </Watermark> */}
            </Content>
          </Layout>
        </Layout>
      </>}
    </>
  );
};

export default MasterTemplate;
